import { getFirestore, doc, getDoc, setDoc, query, collection, where, getDocs } from 'firebase/firestore';
import { auth } from '../config/firebaseConfig';

const db = getFirestore();
const EVENT_ID = process.env.REACT_APP_EVENT_ID; // 이벤트 ID

// 닉네임 중복 체크
export const checkNicknameDuplicate = async (nickname) => {
  try {
    const usersRef = collection(db, 'gameEvent', EVENT_ID, 'users');
    const q = query(usersRef, where('nickname', '==', nickname));
    const querySnapshot = await getDocs(q);
    
    return {
      isDuplicate: !querySnapshot.empty,
      count: querySnapshot.size
    };
  } catch (error) {
    //console.error('닉네임 중복 체크 중 오류:', error);
    throw error;
  }
};

// 사용자 정보 저장
export const saveUserInfo = async (userId, userData) => {
  try {
    const userRef = doc(db, 'gameEvent', EVENT_ID, 'users', userId);
    await setDoc(userRef, {
      ...userData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    return true;
  } catch (error) {
    //console.error('사용자 정보 저장 중 오류:', error);
    throw error;
  }
};

// 사용자 정보 가져오기
export const getUserInfo = async (userId) => {
  try {
    const userRef = doc(db, 'gameEvent', EVENT_ID, 'users', userId);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return userSnap.data();
    } else {
      return null;
    }
  } catch (error) {
    //console.error('사용자 정보 가져오기 중 오류:', error);
    throw error;
  }
};

// 닉네임으로 사용자 검색
export const getUserByNickname = async (nickname) => {
  try {
    const usersRef = collection(db, 'gameEvent', EVENT_ID, 'users');
    const q = query(usersRef, where('nickname', '==', nickname));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0];
      return {
        id: userDoc.id,
        ...userDoc.data()
      };
    } else {
      return null;
    }
  } catch (error) {
    //console.error('닉네임으로 사용자 검색 중 오류:', error);
    throw error;
  }
};

// 이메일 중복 체크
export const checkEmailDuplicate = async (email) => {
  try {
    const usersRef = collection(db, 'gameEvent', EVENT_ID, 'users');
    const q = query(usersRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);
    
    return {
      isDuplicate: !querySnapshot.empty,
      count: querySnapshot.size
    };
  } catch (error) {
    //console.error('이메일 중복 체크 중 오류:', error);
    throw error;
  }
};

// 이메일로 사용자 검색
export const getUserByEmail = async (email) => {
  try {
    const usersRef = collection(db, 'gameEvent', EVENT_ID, 'users');
    const q = query(usersRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0];
      return {
        id: userDoc.id,
        ...userDoc.data()
      };
    } else {
      return null;
    }
  } catch (error) {
    //console.error('이메일로 사용자 검색 중 오류:', error);
    throw error;
  }
}; 